<footer class="footer d-flex flex-column flex-md-row align-items-center justify-content-between px-4 py-3 border-top small">
  <p class="text-muted mb-1 mb-md-0">&copy; 2023 สงวนลิขสิทธิ์ทุกประการ</p>
  <p class="text-muted">สำนักงานส่งกำลังบำรุง สำนักงานตำรวจแห่งชาติ เลขที่ 52 ถนนเศรษฐศิริ แขวงถนนนครไชยศรี เขตดุสิต กรุงเทพฯ 10300</p>
</footer>